import React from 'react';
import { PurchaseGlobalStyle } from './styles';
import { GlobalStyle as WebUiGlobalStyle } from '@sunbit-dev/web-ui-lib';

export const GlobalStyle = () => (
  <>
    <PurchaseGlobalStyle />
    <WebUiGlobalStyle />
  </>
);
